/**
 * UI chrome liviano de Caja (tab bar).
 * Equipo y otros módulos deben usar `shared/ui/UnderlineTabBar` — no este barrel.
 */
export {
  CashUnderlineTabBar,
  type CashUnderlineTabOption,
} from './screens/workspace/CashUnderlineTabBar';

/**
 * Detalle + acciones del cheque (deposit/endorse/reject/return). La usa Cartera
 * y la ficha del cliente (lazy-require desde customers por el ciclo cash↔customers).
 */
export {
  CheckDetailActions,
  type CheckActionSubmit,
  type CheckActionSubmitParams,
} from './screens/CheckDetailActions';
